<template>
    <meta name="gtm_event" :content="props.eventName" />
</template>
<script setup>
import { onMounted } from "vue";
import { pushGAEvent } from "@/analyticsHelper";

const props = defineProps({
    eventName: {
        type: String,
        required: true,
    },
    data: {
        type: Object,
        required: false,
        default: () => {},
    },
});

onMounted(() => {
    window.addEventListener("load", () => {
        const eventData = {
            source_url: window.location.href,
        };

        Object.assign(eventData, props.data);

        pushGAEvent(props.eventName, eventData);
    });
});
</script>
